import { render, staticRenderFns } from "./DocumentViewItemEditorJS.vue?vue&type=template&id=cbc77446&"
import script from "./DocumentViewItemEditorJS.vue?vue&type=script&lang=js&"
export * from "./DocumentViewItemEditorJS.vue?vue&type=script&lang=js&"
import style0 from "./DocumentViewItemEditorJS.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports